import { IVisaPrepForm, Relationship } from '../../../../../../types/index.d';

type Fields = Pick<IVisaPrepForm, 'otherTravellers' | 'travellingWithOthers'>;

type Params = Fields;

export function getPageStatus({ otherTravellers, travellingWithOthers }: Params): { complete: boolean } {
  let complete = false;

  if (travellingWithOthers !== undefined) {
    if (travellingWithOthers === false) {
      complete = true;
    } else {
      let formComplete = true;
      if (!otherTravellers || otherTravellers.length === 0) {
        formComplete = false;
      } else {
        complete = !otherTravellers.some(details => {
          return (
            details.relationship === undefined ||
            (details.relationship === Relationship.OTHER && details.relationshipOther === '') ||
            details.adultOrChild === '' ||
            details.nationality === '' ||
            details.sameNationality === undefined ||
            details.familyName === '' ||
            details.givenName === '' ||
            details.dob === '' ||
            details.ukVisa === undefined ||
            details.hasPassport === undefined ||
            (details.hasPassport === true && details.passportNumber === '')
          );
        });
      }

      complete = formComplete;
    }
  }

  return { complete };
}

export function relationshipLabel(relationship: string) {
  switch (relationship) {
    case Relationship.GUARDIAN:
      return 'Guardian';
    case Relationship.FRIEND:
      return 'Friend';
    case Relationship.SISTER:
      return 'Sister';
    case Relationship.BROTHER:
      return 'Brother';
    case Relationship.AUNT:
      return 'Aunt';
    case Relationship.UNCLE:
      return 'Uncle';
    case Relationship.COUSIN:
      return 'Cousin';
    case Relationship.GRANDPARENT:
      return 'Grandparent';
    case Relationship.NON_DEPENDANT:
      return 'Non-dependant';
    case Relationship.OTHER:
      return 'Other';
    default:
      return '';
  }
}
